import React from 'react';
import classnames from 'classnames';

import style from './index.less';

const AudioImage = props => {
  const { playing } = props;

  return (
    <div className={classnames(style['audio-box'], { playing })}>
      &nbsp;
      <div className={style['wifi-symbol']}>
        <div className={classnames(style['wifi-circle'], style.first)} />
        <div className={classnames(style['wifi-circle'], style.second)} />
        <div className={classnames(style['wifi-circle'], style.third)} />
      </div>
    </div>
  );
};

export default AudioImage;
